import { WbEditor } from '@agilelab/plugin-wb-platform';
import { Box, CircularProgress, Paper, useTheme } from '@material-ui/core';

export function PreviewDescriptorBox(props: {
  code: string | null | undefined;
  name: string;
  loading: boolean;
  showLineNumbers?: boolean;
  highlightedNumbers?: number[];
}) {
  const { code, loading } = props;
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      style={{
        padding: theme.spacing(2),
        height: '100%',
        overflow: 'hidden',
        flex: '1 1 0',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {loading && (
        <Box
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <CircularProgress />
        </Box>
      )}
      {!loading && code && (
        <WbEditor
          value={code}
          options={{ readOnly: true }}
          wrapperProps={{
            padding: '0',
            margin: '0',
            height: '100%',
            flex: '1 1 0',
            backgroundColor: theme.palette.background.paper,
            display: 'flex',
            flexDirection: 'column',
          }}
        />
      )}
    </Paper>
  );
}
